import type { CustomerRatingsConfig } from '../../default/product/customerRatings.types';
import type { DeepPartial } from '../../default/types';

export const customerRatingsConfig: DeepPartial<CustomerRatingsConfig> = {
  ratingButtonEnabled: false,
  forceEnableRatingButtonParam: 'openWriteReview',
};
